export default __webpack_public_path__ + "static/wall-416062_1280-efb87f018318eb58607fb3f16cf6f66d.png";